// src/services/api/testimonialService.ts
import { api } from "./api";
import { ITestimonial } from "../../types/testimonial";
import { config } from "../../config/environment";

//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CLINIC_ID = config.clinic.id;

// Types for request payloads
//export interface CreateTestimonialPayload
//  extends Omit<ITestimonial, "clinicId" | "testimonialId" | "_id"> {
//  slug?: string;
//}

//export type UpdateTestimonialPayload = Partial<CreateTestimonialPayload>;

export const testimonialService = {
  getAllTestimonials: async () => {
    const response = await api.get<ITestimonial[]>(
      `/clinics/${CLINIC_ID}/testimonials`
    );
    return response.data;
  },

  getTestimonialById: async (testimonialId: string) => {
    const response = await api.get<ITestimonial>(
      `$/clinics/${CLINIC_ID}/testimonials/${testimonialId}`
    );
    return response.data;
  },

  createTestimonial: async (testimonial: ITestimonial) => {
    const response = await api.post<ITestimonial>(
      `$/clinics/${CLINIC_ID}/testimonials`,
      testimonial
    );
    return response.data;
  },

  updateTestimonial: async (
    testimonialId: string,
    testimonial: ITestimonial
  ) => {
    const response = await api.put<ITestimonial>(
      `$/clinics/${CLINIC_ID}/testimonials/${testimonialId}`,
      testimonial
    );
    return response.data;
  },

  deleteTestimonial: async (testimonialId: string) => {
    await api.delete(`$/clinics/${CLINIC_ID}/testimonials/${testimonialId}`);
  },
};
